import Vue from 'vue'
import rolebleMixin from '@/mixins/rolebleMixin'
import {
  disputableMixin,
  doneGigJobManageMixin,
  gigJobPartiesMixin,
  offerManageMixin,
  payableMixin,
  refundableMixin,
  reviewableMixin,
  startableMixin,
} from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [
    disputableMixin,
    doneGigJobManageMixin,
    gigJobPartiesMixin,
    offerManageMixin,
    payableMixin,
    refundableMixin,
    reviewableMixin,
    rolebleMixin,
    startableMixin,
  ],
  computed: {
    hasBtns() {
      return (
        this.hasGigWasDone ||
        this.hasSendOffer ||
        this.hasGigDone ||
        this.hasCreateDispute ||
        this.hasStartJob ||
        this.hasPayJob ||
        this.hasRefund ||
        this.hasLeaveReview ||
        this.hasReviewed
      )
    },
  },
  methods: {
    onDoneClick() {
      this.markGigJobAsDone()
    },
    onCancelGigDoneClick() {
      this.markGigJobAsNotDone()
    },
    onSendOfferClick() {
      this.createOffer()
    },
    onStartJobClick() {
      this.startJob()
    },
    onPayToTalentClick() {
      this.payToTalent()
    },
    onLeaveReviewClick() {
      this.leaveReview()
    },
    onCreateDisputeClick() {
      this.createDispute()
    },
    onRefundClick() {
      this.refundToCustomer()
    },
  },
})
